export default __webpack_public_path__ + "static/media/how_to_use_platform.da4e4549.mp4";